import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LineItemModel } from '../../../../models/template.model';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { normalizeRichTextHtml } from '../../../../shared/utils/rich-text-html.util';

@Component({
  selector: 'app-labeltext-control',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="labeltext-control-container">
      @if (lineItem().name) {
        <div class="labeltext-title">{{ lineItem().name }}</div>
      }
      <div class="labeltext-content ql-snow"><div class="ql-editor" [innerHTML]="sanitizedHtml"></div></div>
    </div>
  `,
  styles: [`
    .labeltext-control-container {
      padding: 14px 16px;
      background-color: var(--color-primary-50);
      border-left: 4px solid var(--color-primary-500);
      border-radius: 4px;
    }

    .labeltext-title {
      font-size: 14px;
      font-weight: var(--font-weight-semibold);
      color: var(--color-text-primary);
      margin-bottom: 8px;
      padding-bottom: 8px;
      border-bottom: 1px solid var(--color-border-default);
    }

    .labeltext-content {
      font-size: 14px;
      line-height: 1.6;
      color: var(--color-text-primary);
    }

    .labeltext-content :deep(p) {
      margin: 0.5rem 0;
    }

    .labeltext-content :deep(.ql-editor) {
      height: auto !important;
      overflow-y: visible !important;
      padding: 0;
    }

    .labeltext-content :deep(.ql-editor ul),
    .labeltext-content :deep(.ql-editor ol) {
      margin: 0.5rem 0;
      padding-left: 1.5rem;
    }

    .labeltext-content :deep(.ql-editor ul > li) {
      list-style-type: disc;
      list-style-position: outside;
      padding-left: 0;
    }

    .labeltext-content :deep(.ql-editor ol > li) {
      list-style-type: decimal;
      list-style-position: outside;
      padding-left: 0;
    }

    .labeltext-content :deep(strong) {
      font-weight: 600;
    }

    .labeltext-content :deep(em) {
      font-style: italic;
    }

    .labeltext-content :deep(u) {
      text-decoration: underline;
    }

  `]
})
export class LabeltextControlComponent {
  lineItem = input.required<LineItemModel>();

  constructor(private sanitizer: DomSanitizer) {}

  get sanitizedHtml(): SafeHtml {
    // Use bypassSecurityTrustHtml to preserve inline styles (colors, etc.)
    // Safe because content comes from trusted admin users
    return this.sanitizer.bypassSecurityTrustHtml(normalizeRichTextHtml(this.lineItem().defaultText));
  }
}
